import { FetchBaseQueryError } from "@reduxjs/toolkit/query/react"

export interface Error {
    message: string
    key: string
}

export interface ErrorResponse {
    error: Error
}

export const isErrorResponse = (value: unknown): value is ErrorResponse => {
    if (typeof value !== "object" || value === null) {
        return false
    }

    const response = value as Partial<ErrorResponse>

    return (
        typeof response.error === "object" &&
        response.error !== null &&
        typeof response.error.message === "string" &&
        typeof response.error.key === "string"
    )
}

export interface ApiError {
    Message: string
    Key: string
    Params: Record<string, unknown>
}

export interface ApiErrorResponse {
    Errors: ApiError[]
}

export interface FetchErrorResponse {
    error: FetchBaseQueryError
    isUnhandledError: boolean
    meta: Record<string, unknown>
}
